import { AddressResolver } from "@shared/execution/types";
import { FilterCondition, Flowstep } from "@shared/types/flowstep";
import { resolveFilterSubstitutions } from "@shared/utils/filterManager";
import { loadRangesValues, loadTableValues } from "src/services/substitution";
import { substituteQuery as substitute } from "shared/utils/querySubstitution";
import { FlowstepType } from "shared/utils/flowstep";

export class SalesforceFrontendAddressResolver implements AddressResolver {
  constructor() {}

  async resolveConditionValues(flowstep: Flowstep) {
    const conditions = flowstep.providerOptions?.conditions as FilterCondition[];
    const { worksheetId } = flowstep.options;

    flowstep.providerOptions.conditions = await Excel.run(async (context) => {
      return await resolveFilterSubstitutions(conditions, {
          tablesLoader: async (tables: any) => await loadTableValues(context, tables),
          rangesLoader: async (ranges: any) => await loadRangesValues(context, ranges, worksheetId),
        }
      );
    });
  }

  async resolveQuery(flowstep: Flowstep) {
    const { worksheetId } = flowstep.options;
    const query = flowstep.providerOptions?.query;

    if (query) {
      flowstep.providerOptions.query = await Excel.run(async (context) => {
        return await substitute(query, FlowstepType.Soql, {
          tablesLoader: async (tables: any) => await loadTableValues(context, tables),
          rangesLoader: async (ranges: any) => await loadRangesValues(context, ranges, worksheetId),
        });
      });
    }
  }

  async replaceAddressesByValues(flowstep: Flowstep): Promise<Flowstep> {
    const clone = structuredClone(flowstep);
    await this.resolveQuery(clone);
    return clone;
  }

}
